import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CreateEventPage from './pages/CreateEventPage';
import EditEventPage from './pages/EditEventPage';
import ModLoginPage from './pages/ModLoginPage';
import ModeratorPage from './pages/ModeratorPage';
import TermsPage from './pages/TermsPage';
import SearchPage from './pages/SearchPage';
import { useAuthState } from './hooks/useAuthState';
import { TranslationProvider, detectLanguage } from './i18n';

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

setupIonicReact();

const HomeRedirect: React.FC = () => {
  React.useEffect(() => {
    const lang = detectLanguage();
    const path = lang === 'en' ? '/en/' : lang === 'pt' ? '/pt-BR/' : '/es/';
    window.location.replace(path);
  }, []);
  return null;
};

const App: React.FC = () => {
  const { user, loading } = useAuthState();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#f0f0f1',
      }}>
        <div style={{
          width: 40,
          height: 40,
          border: '3px solid rgba(34, 113, 177, 0.2)',
          borderTopColor: '#2271b1',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <TranslationProvider>
      <IonApp>
        <IonReactRouter>
          <IonRouterOutlet>
            <Route exact path="/login">
              {user ? <Redirect to="/dashboard" /> : <LoginPage />}
            </Route>

            <Route exact path="/dashboard">
              {user ? <DashboardPage /> : <Redirect to="/login" />}
            </Route>

            <Route exact path="/create-event">
              {user ? <CreateEventPage /> : <Redirect to="/login" />}
            </Route>

            <Route exact path="/edit-event/:eventId">
              {user ? <EditEventPage /> : <Redirect to="/login" />}
            </Route>

            <Route exact path="/mod-login">
              <ModLoginPage />
            </Route>

            <Route exact path="/moderator">
              <ModeratorPage />
            </Route>

            <Route exact path="/search">
              <SearchPage />
            </Route>

            <Route exact path="/es/search">
              <SearchPage />
            </Route>

            <Route exact path="/en/search">
              <SearchPage />
            </Route>

            <Route exact path="/pt-BR/search">
              <SearchPage />
            </Route>

            <Route exact path="/es/terms">
              <TermsPage />
            </Route>

            <Route exact path="/en/terms">
              <TermsPage />
            </Route>

            <Route exact path="/pt-BR/terms">
              <TermsPage />
            </Route>

            <Route exact path="/">
              {user ? <Redirect to="/dashboard" /> : <HomeRedirect />}
            </Route>
          </IonRouterOutlet>
        </IonReactRouter>
      </IonApp>
    </TranslationProvider>
  );
};

export default App;